import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs';
import { UserService } from './user.service';
import { environment } from '@env/environment';

// Read: https://www.npmjs.com/package/msal
// Wiki: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL.js-1.0.0-api-release#configuration-options

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user$ = this.userService.getUser();

  constructor(private userService: UserService) {}

  logout() {
    window.location.assign('/logout');
  }
}
